import React, { Fragment } from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        var accountId = this.props.match.params.account_id;
        const dataHmac = {
            url: `/admin/clients/accounts/${accountId}/apihmac`,
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRCLIENTAPIACCESSID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'API Access username',
                        source: 'ATRUSERNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'Username...'
                    },
                    {
                        label: 'Access Secret',
                        source: 'ATRHMACSECRET',
                        type: 'password',
                        default: 'RANDOM',
                        pattern: '[0-9a-f]{12}',
                        editable: false,
                        visible: true,
                        regenerate: true,
                        placeholder: ''
                    },
                    {
                        label: 'Authentication Algo',
                        source: 'ATRHMACALGO',
                        type: 'select',
                        default: 'SHA256',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'checkbox',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label : 'Actions',
                        type: 'action_buttons'
                    }
                ]
        }
        const dataToken = {
            url: `/admin/clients/accounts/${accountId}//apitoken`,
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRCLIENTAPIACCESSID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'API Access Name',
                        source: 'ATRUSERNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'Some descriptive name...'
                    },
                    {
                        label: 'Access Token',
                        source: 'ATRTOKENHASH',
                        type: 'password',
                        default: 'RANDOM',
                        pattern: '\\w{16}',
                        editable: false,
                        visible: true,
                        regenerate: true,
                        placeholder: ''
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'checkbox',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label : 'Actions',
                        type: 'action_buttons'
                    }
                ]
        }

        return (
            <Fragment>
                <Panel title = "Token based API Access">
                    <Resource
                        addButtonText = "Add Token API Access"                 
                        data = {dataToken}
                        {...this.props} 
                    />
                </Panel>
                <Panel title = "HMAC based API Access">
                    <Resource
                        addButtonText = "Add HMAC API Access"                    
                        data = {dataHmac}
                        {...this.props} 
                    />
                </Panel>
            </Fragment>
        )
    }
}
  